import * as util from '../../../globals/methods/util';

const getObjKey = util.getObjKey;

export const getSelectedBankDocumentId = (state) => {
    return state.bankReport.bankDocumentId;
};

export const isDocumentSelected = (state, documentId) => {
    return getSelectedBankDocumentId(state) === documentId;
};

export const getCurrentBankReport = (state) => {
    return state.bankReport.report;
};

export const getIsFetchingBankReport = (state) => {
    return state.bankReport.fetchingBankReport;
};

export const getFailedFetchingBankReport = (state) => {
    return state.bankReport.failedFetchingBankReport;
};

export const getSelectedTransaction = (state) => {
    return state.bankReport.selectedTransaction;
};

export const getSelectedBankAccount = (state) => {
    return state.bankReport.selectedBankAccount;
};

export const getSelectedBankAccountLast4 = (state) => {
    const accountNumber = getObjKey(state, 'bankReport.selectedBankAccount.AccountNumberFound', '');
    const length = accountNumber.length;
    return length >= 4 ? accountNumber.substring(length - 4, length) : undefined;
};

export const getHasSelectedTransaction = (state) => {
    return state.bankReport.hasSelectedTransaction;
};

export const getHasSelectedBankStatement = (state) => {
    return state.bankReport.hasSelectedBankStatement;
};

export const getHasSelectedBankReport = (state) => {
    return state.bankReport.hasSelectedBankReport;
};

export const getBankStatementUrl = (state) => {
    return state.bankReport.bankStatementUrl;
};

export const getBankReportError = (state) => {
    return state.bankReport.error;
};